module.exports = __webpack_public_path__ + "static/media/zadania-powtorkowe-do-egzaminu-osmoklasisty-matematyka-8-4.3a6980b7.jpg";